import { CloudCommand } from "../types.js";

export const downloadFile: CloudCommand = {
    action: "FILE/DOWNLOAD_FILE",
    commandName: "file.downloadFile",
    buildPayload: ({ params }) => ({ params }),
};
